<template>
  <div class="tools-container">
    <div
      :class="[
        'item',
        {
          'is-active': UIStatus.marker,
        },
      ]"
      @click="handleToolClick('point')"
    >
      <el-tooltip content="点操作" placement="left">
        <img src="../../../asset/point.png" />
      </el-tooltip>
    </div>
    <div
      :class="[
        'item',
        {
          'is-active': UIStatus.polygon,
        },
      ]"
      @click="handleToolClick('polygon')"
    >
      <el-tooltip content="面操作" placement="left">
        <div>
          <img src="../../../asset/duobianxing.png" />
        </div>
      </el-tooltip>
    </div>

    <div :class="['item']" @click="handleToolClick('lanLon')">
      <el-tooltip content="经纬度搜索" placement="left">
        <img src="../../../asset/jingweidu.png" />
      </el-tooltip>
    </div>
    <div :class="['item']" @click="handleToolClick('city')">
      <el-tooltip content="城市搜索" placement="left">
        <img src="../../../asset/xingzhengqu.png" />
      </el-tooltip>
    </div>
    <!-- <div
      :class="[
        'item',
        {
          'is-active': UIStatus.rectangle
        }
      ]"
      @click="handleToolClick('rect')"
    >
      <el-tooltip content="矩形操作" placement="bottom">
        <img :src="RectIcon" />
      </el-tooltip>
    </div>
    <div
      :class="[
        'item',
        {
          'is-active': UIStatus.polygon
        }
      ]"
      @click="handleToolClick('polygon')"
    >
      <el-tooltip content="多边形操作" placement="bottom">
        <img :src="PolyIcon" />
      </el-tooltip>
    </div>
    <div
      v-if="isLogin && this.$route.name !== 'project-list'"
      :class="[
        'item',
        {
          'is-active': UIStatus.newFarm
        }
      ]"
      @click="handleNewWindFarmClick"
    >
      <el-tooltip content="新建风场" placement="bottom">
        <img :src="newFarm" />
      </el-tooltip>
    </div>
    <div
      v-if="isLogin && this.$route.name !== 'project-list'"
      :class="[
        'item',
        {
          'is-active': UIStatus.importFarm
        }
      ]"
      @click="importFile"
    >
      <el-tooltip content="导入风场" placement="bottom">
        <img :src="ImportIcon" />
      </el-tooltip>
    </div> -->
  </div>
</template>

<script>
import PointIcon from '../images/tool_02.png';
import RectIcon from '../images/tool_03.png';
import PolyIcon from '../images/tool_04.png';
import newFarm from '../images/tool_05.png';
import ImportIcon from '../images/tool_06.png';
import { mapGetters } from 'vuex';

export default {
  props: {
    UIStatus: {
      type: Object,
      default: () => {
        return {
          search: false,
          marker: false,
          rectangle: false,
          polyline: false,
          newFarm: false,
          importFarm: false,
        };
      },
    },
  },
  data() {
    return {
      ImportIcon,
      PointIcon,
      RectIcon,
      PolyIcon,
      newFarm,
    };
  },
  methods: {
    handleNewWindFarmClick() {
      this.$emit('newWindFarm');
    },
    importFile() {
      this.$emit('importFile');
    },
    handleSearchClick() {
      this.$emit('seachClick');
    },
    handleToolClick(type) {
      this.$emit('mapToolClick', type);
    },
  },
  computed: {
    ...mapGetters(['isLogin']),
  },
};
</script>

<style lang="less" scoped>
.tools-container {
  position: absolute;
  top: 55px;
  height: 50px;
  right: 5px;
  z-index: 500;
  // display: flex;

  .item {
    width: 36px;
    height: 36px;
    background: #20405d;
    border: solid 2px #89c6ff;
    color: #a3d3ff;
    margin-bottom: 5px;
    text-align: center;
    cursor: pointer;
    //user-select: none;
    padding: 7px;
    box-sizing: border-box;
    img {
      display: flex;
      width:100% ;
      height: 100%;
    }
  }
}
</style>
